import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormListGeneratorComponent} from './form-list-generator.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CheckboxFieldComponent} from './checkbox-field.component';
import {SelectFieldComponent} from './select-field.component';
import {InputFieldComponent} from './input-field.component';
import {CalenderFieldComponent} from './calender-field.component';
import {TextFieldComponent} from './text-field.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { RadioButtonComponent } from './radio-button.component';
import {MatRadioModule} from '@angular/material/radio';
import { StateAndCityFieldComponent } from './state-and-city-field.component';
import { CompanyFieldComponent } from './company-field.component';
import { CompanyFranchiseFieldComponent } from './company-franchise-field.component';
import { LimitedIntegerListSelectComponent } from './limited-integer-list-select.component';
import { DeviceTypeBrandModelListComponent } from './device-type-brand-model-list.component';



@NgModule({
  declarations: [
    FormListGeneratorComponent,
    CheckboxFieldComponent,
    SelectFieldComponent,
    InputFieldComponent,
    CalenderFieldComponent,
    TextFieldComponent,
    RadioButtonComponent,
    StateAndCityFieldComponent,
    CompanyFieldComponent,
    CompanyFranchiseFieldComponent,
    LimitedIntegerListSelectComponent,
    DeviceTypeBrandModelListComponent
  ],
  exports: [
    FormListGeneratorComponent,
    CheckboxFieldComponent,
    SelectFieldComponent,
    InputFieldComponent,
    CalenderFieldComponent,
    TextFieldComponent,
    RadioButtonComponent,
    StateAndCityFieldComponent,
    CompanyFieldComponent
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatCardModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        MatInputModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatRadioModule
    ]
})
export class FormListGeneratorModule { }
